import React from 'react'

import { useTableContext } from './TableContext'
import { IAction } from './TableReducer'

export interface HeaderActionProps {
  data: {
    [key: string]: number | string | boolean
  }[]
  dispatch: React.Dispatch<IAction>
}

export interface TableHeaderProps {
  actions?: React.FC<HeaderActionProps>[]
}

export const TableHeader: React.FC<TableHeaderProps> = ({ actions }) => {
  const { data, dispatch } = useTableContext()
  return (
    <div className="cb-margin-bottom-10">
      <div className="display-flex flex-wrap justify-content-end flex-xs-column flex-md-row">
        {actions &&
          actions.map((Action) => {
            return (
              <div className="cb-margin-right-16" key={Date.now()}>
                <Action data={data} dispatch={dispatch} />
              </div>
            )
          })}
        {actions && !(actions instanceof Array) && (
          <div className="cb-margin-right-16">{actions}</div>
        )}
      </div>
    </div>
  )
}
